'use client';

import { c as _c } from "react/compiler-runtime";
import type { ButtonProps } from '@repo/ui';
import { Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui';
import { ArrowDiagonalUp } from '@repo/ui/icons';
import { memo } from 'react';
import { ButtonLink } from '../ButtonLink';
export interface LinkIconProps {
  tooltip: string;
  href: string;
  /** Defaults to the filled treatment; pass `outline` where the icon sits on a card. */
  variant?: ButtonProps['variant'];
}
const LinkIcon = t0 => {
  const $ = _c(12);
  const {
    tooltip,
    href,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "secondary" : t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ArrowDiagonalUp />;
    t3 = {
      className: "text-secondary-foreground"
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] !== variant) {
    t4 = {
      variant,
      size: "sm",
      iconRight: undefined,
      iconAlone: t2,
      iconAloneProps: t3
    };
    $[2] = variant;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== href || $[5] !== t4) {
    t5 = <TooltipTrigger asChild={true}><div className="flex items-center"><ButtonLink href={href} className="flex" buttonProps={t4} /></div></TooltipTrigger>;
    $[4] = href;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== tooltip) {
    t6 = <TooltipContent>{tooltip}</TooltipContent>;
    $[7] = tooltip;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <Tooltip>{t5}{t6}</Tooltip>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
export default memo(LinkIcon);